import { type IEntitlementRepository } from '@webapp/core/business-logic/interfaces/IEntitlementRepository'
import { EntitlementRepositoryValidationError } from '@webapp/core/data-access/repositories/EntitlementRepository'
import { type Entitlement } from '@webapp/core/types/Entitlement'
import { EntitlementServiceError } from './errors'
import { type EntitlementAccessConfig } from './types'

// Defaults live in ./constants so they can be consumed without loading the
// repository/ApiClient stack; re-exported here to preserve this module's
// public API.
export { ENTITLEMENT_ACCESS_CONFIG_DEFAULTS } from './constants'

export class EntitlementService {
  constructor(readonly repository: IEntitlementRepository) {}

  transformEntitlement = (
    entitlement: Entitlement
  ): EntitlementAccessConfig => {
    return {
      module: {
        angular: {
          dashboard: {
            expense: { enabled: entitlement.expenses.enabled },
            order: { enabled: entitlement.purchasing.enabled },
            travel: { enabled: entitlement.expenses.enabled },
          },
        },
        purchasing: {
          enabled: entitlement.purchasing.enabled,
        },
        expense: {
          enabled: entitlement.expenses.enabled,
        },
        spendingCard: {
          enabled: entitlement.spendingCards.enabled,
        },
        ap: {
          everythingButExpense: {
            enabled: entitlement.ap.enabled,
          },
          expenseAp: {
            enabled: entitlement.expenses.enabled,
          },
        },
        contracts: {
          enabled: entitlement.contracts.enabled,
        },
        budgets: {
          enabled: entitlement.budgets.enabled,
        },
      },
    }
  }

  async getEntitlement(): Promise<Entitlement> {
    try {
      return await this.repository.getEntitlement()
    } catch (error) {
      if (error instanceof EntitlementRepositoryValidationError) {
        throw new EntitlementServiceError(
          'Invalid entitlement configuration received',
          error
        )
      }
      throw new EntitlementServiceError(
        'Failed to load entitlements',
        error as Error
      )
    }
  }

  async getEntitlementAccessConfig(): Promise<EntitlementAccessConfig> {
    const entitlementData = await this.getEntitlement()
    return this.transformEntitlement(entitlementData)
  }
}
